import { environment } from "src/environments/environment";
import { Config } from "../landing-config";
import { ico_picked } from "../map-config";

const maxFileRows = 500;
export const SOPRALLUOGO_CONFIG: Config = {
    data: {
        route: 'sopralluogo',
        page_title: 'Sopralluogo | Open Fiber',
        service_title: 'Sopralluogo',
        service_description: '',
        service_name: '',
        service_slug: 'sopralluogo',
        errorTimeout: 10000,
        feasibilityModelSingle: false,
        feasibilityEnabled: true,
        api: {
            massiveImport: {
                massiveDetailsPath: '/serviziosopralluogo/massivep2p/detail',
                massiveUploadPath: '/point/serviziosopralluogo/massivep2p/upload',
                massiveDownloadPath: '/serviziosopralluogo/data/massive/import.xlsx',
                massiveP2pSalesforcePath: '/serviziosopralluogo/massivep2p/send-to-salesforce',
                max_file_rows: maxFileRows,
                info_message: `Le richieste inserite nel file saranno gestite complessivamente, senza possibilità di selezione o raggruppamento parziale. Il file dovrà contenere un massimo di ${maxFileRows} richieste.`
            },
            p2pPath: '/point/serviziosopralluogo/p2p',
			bboxPath: '/marketing/building',
			buildingSearchParams: null
        },
        dynamic_aend_name: 'INSPECTION'
    },
    multiple_points: {
        variable: false,
        max: 1,
        points: {
            b_end: {
                default_method: 'address',
                switch_methods: true,
                address: true,
                pop: false,
                poi: false,
                pfs: false,
                roe: false,
                coordinates: true,
                id_building: true,
                id_bts_noa: false,
                id_bts_building: false,
                id_school: false,
                city_noa: false,
                city_pop: false,
                city_poi: false,
                city_building: false,
                id_healthcare: false,
                upload: true,
                popAndPoiAutocomplete: false,
				punti_intermedi: false,
				pop_pcn_xpop: false
            },
            a_end: null
        },
        initial_points: ['b_end']
    },
    map: {
        map_events: ['click', 'zoom_changed', 'bounds_changed', 'dragend', 'dblclick'],
        marker_has_label: false,
        marker_default_icon: ico_picked,
        clear_markers_zoom_level: 12
    },
    research_methods: {
        id_building: true,
        id_bts_noa: false,
        id_bts_building: false,
        id_school: false,
        id_healthcare: false,
		punti_intermedi: false,
		pop_pcn_xpop: false
    },
    area_types: ['CoveredAB', 'CoveredCD', 'CoveredAGF'],
    area_types_short: null,
    kml: false,
    pop: {
        load: true,
        view_initial: false,
        click: false,
        loadCities: false
    },
    pop_ola: {
        load: false,
        view_initial: false,
        click: false
    },
    pcn: {
        load: true,
        view_initial: false,
        click: false
    },
    pop_agf: {
        load: true,
        view_initial: false,
        click: false
    },
    poi: {
        load: false,
        view_initial: false,
        click: false,
        x_pop: false,
        is_registered: false,
        custom_research_method: 'Address',
        loadCities: false
    },
    pfs: {
        load: false,
        view_initial: false,
        click: false,
        type: 'PFS'
    },
    roe: {
        load: false,
        view_initial: false,
        click: false,
        type: 'ROE'
    },
    cno: {
        load: false,
        view_initial: false,
        click: false,
        type: 'CNO'
    },
    pozzetto: {
        load: false,
        view_initial: false,
        click: false,
        type: 'POZZETTO'
    },
    building: {
        load: true,
        click: true,
        placeholder: 'Insert Building ID'
    },
    noa: {
        load: false,
        click: false,
        placeholder: 'Insert NOA ID'
    },
    bts: {
        load: false,
        types: null
    },
    punti_intermedi: {
        load: false,
        types: null
	},
	pop_pcn_xpop: {
        load: false,
        types: null
    },
    school: {
        load: false,
        click: false,
        placeholder: 'Insert School ID'
    },
    healthcare: {
        load: false,
        click: false,
        placeholder: 'Insert Healthcare ID'
    }
}
